/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createHook } from '../../core/factories/createHook.js';

import { createPrefetchHook } from '../../core/factories/createPrefetchHook.js';
import type { GetImageModerationStatusRow } from '../openapi-types.gen.js';
import { type useGetImageModerationStatusArgs, useGetImageModerationStatusSpec } from '../specs/images.spec.gen.js';

export type { GetImageModerationStatusRow } from '../openapi-types.gen.js';
export type { useGetImageModerationStatusArgs } from '../specs/images.spec.gen.js';


/**
 * Available query params (forwarded automatically; pass via the
 * hook's args): sha256.
 */
export const useGetImageModerationStatus = createHook(useGetImageModerationStatusSpec);


/**
 * Hover/intent prefetch companion for `useGetImageModerationStatus`. Returns a stable
 * `(args) => Promise<void>` callback that fires the real HTTP request
 * and writes the response into the SAME cache entry the reader hook
 * observes. The component owning the callback does NOT subscribe — no
 * re-renders on data, no NATS subscription. Idempotent: TanStack
 * `prefetchQuery` is a no-op when a fresh cache entry already exists.
 *
 *     function Link({ pubkey }) {
 *       const prefetch = usePrefetchGetImageModerationStatus();
 *       return (
 *         <a
 *           onMouseEnter={() => prefetch({ pubkey })}
 *           onFocus={() => prefetch({ pubkey })}
 *         >…</a>
 *       );
 *     }
 */
export const usePrefetchGetImageModerationStatus = createPrefetchHook(useGetImageModerationStatusSpec);
